<script setup lang="ts">
  import {
    authContentClass,
    authContentWrapperClass,
    authHeaderWrapperClass,
    headerSubitleClass,
    headerTitleClass,
  } from './AuthPageContent.css.ts';
  import { Illustration } from '@tundr/ds-components';

  defineProps<{
    title: string;
    subTitle?: string;
    image?: string;
  }>();
</script>

<template>
  <div :class="authContentWrapperClass">
    <div :class="authHeaderWrapperClass">
      <slot name="image">
        <Illustration v-if="image" :src="image" :height="80" :width="80" />
      </slot>
      <h1 :class="headerTitleClass">{{ title }}</h1>
      <div>
        <span v-if="subTitle" :class="headerSubitleClass">{{ subTitle }}</span>
        <slot name="actions" />
      </div>
    </div>
    <div :class="authContentClass"><slot /></div>
  </div>
</template>
